// angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// env
import { environment } from '../config/environments/environment';

// firebase
import { AngularFireModule } from '@angular/fire';
import { AngularFireMessagingModule } from '@angular/fire/messaging';


@NgModule({
  imports: [
    CommonModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule,
  ],
  declarations: []
})
export class AppFirebaseModule { }
